import React from 'react';
import { RedocStandalone } from 'redoc';

const Redoc = () => {
    return (
        <RedocStandalone
            specUrl="endpoints.yaml"
            options={{
                nativeScrollbars: false,
                hideDownloadButton: true,
                noAutoAuth: true,
                expandDefaultServerVariables: true,
                onlyRequiredInSamples: false,
                hideLoading: true,
                expandResponses: '200',
                theme: {
                    colors: {
                        primary: {
                            main: '#474e54',
                        },
                    },  
                    typography: {
                        links: {
                        color: '#0366d6',
                        hover: '#e53935',
                        visited: '#CBC3E3',
                        },
                    },
                },
            }}
        />
    );
};

export default Redoc;
